import { useState, useEffect, useMemo } from "react";
import axios from "../config/axios";
import PageWrapper from "../components/common/PageWrapper";
import Header from "../components/common/Header";
import BodyWrapper from "../components/common/BodyWrapper";
import Footer from "../components/common/Footer";
import PlanCard from "../components/planPartials/PlanCard";
import { useGeneral } from "../components/contexts/GeneralContext";
import FullScreenLoading from "../components/common/loading/FullScreenLoading";
import ApiErrorMessage from "../components/common/ApiErrorMessage";
import NoItemsFound from "../components/common/NoItemsFound";
import GeneralButton from "../components/common/GeneralButton";
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { useStep } from "../components/contexts/SubscriptionContext";
import { useNavigate } from "react-router-dom";

const usePlanPageContent = () => {
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState([]);
  const [error, setError] = useState("");
  const { discountCoupons } = useGeneral();

  useEffect(() => {
    let active = true;

    (async () => {
      try {
        const { data } = await axios.get("get-plans");
        if (active) setContent(data);
      } catch (err) {
        console.error(err);
        if (active) setError("Failed to load plans. Please try again later.");
      } finally {
        if (active) setLoading(false);
      }
    })();

    return () => {
      active = false;
    };
  }, []);

  return { content, loading, error, discountCoupons };
};

const useScrollToTop = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }, 100);
    return () => clearTimeout(timer);
  }, []);
};

const PlansPage = () => {
  const { content, loading, error, discountCoupons } = usePlanPageContent();
  useScrollToTop();
  const { nextStep, prevStep, goToStep } = useStep();
  const navigate = useNavigate();
  // Memoize mapped PlanCards for performance
  const planCards = useMemo(
    () =>
      content.map((item) => (
        <PlanCard key={item.id || item.title} item={item} />
      )),
    [content],
  );

  return (
    <>
      {loading && <FullScreenLoading />}
      <PageWrapper loading={loading} className="bg-bg min-h-screen">
        <Header code={discountCoupons} />
        <BodyWrapper loading={loading}>
          {!loading && error ? (
            <ApiErrorMessage
              message1="Failed to load plans"
              message2="Please check your connection and try again."
            />
          ) : !loading && content.length === 0 ? (
            <NoItemsFound
              message1="No plans available"
              message2="Please check back later."
            />
          ) : (
            <div className="bg-orange rounded-[25px] grid xl:grid-cols-[1fr_4fr] 2.5xl:grid-cols-[1fr_6fr] p-6 xl:p-10 gap-4 xl:gap-0">
              <div>
                {" "}
                <div className="flex flex-col gap-0">
                  <h2 className="text-32pt  leading-none text-white">
                    Getting
                  </h2>
                  <h2 className="text-48pt lg:text-[30pt] 1xl:text-48pt leading-none font-extrabold text-white mb-2">
                    Started
                  </h2>
                  <GeneralButton
                    text="Choose a plan"
                    title=""
                    bgColor="#30160E"
                    textColor="#A0AE3F"
                    hoveredTextColor="#A0AE3F"
                    className="text-24pt lg:text-20pt 1xl:text-24pt leading-tight cursor-default"
                    // onClick={() => {
                    //   goToStep("1");
                    //   navigate("/subscribe/plan");
                    // }}
                    textType=""
                    icon={
                      <HiChevronRight className="text-24pt hidden md:block" />
                    }
                  />
                  <GeneralButton
                    text="View all meals"
                    title=""
                    bgColor="#A0AE3F"
                    className="text-24pt lg:text-20pt 1xl:text-[23.5px] leading-tight cursor-pointer mt-2"
                    onClick={() => {
                      navigate("/meals");
                    }}
                    textType=""
                    // icon={
                    //   <HiChevronRight className="text-24pt hidden md:block" />
                    // }
                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4 lg:gap-10">
                {planCards}
                {/* <div className="flex justify-end">
                  <GeneralButton
                    text="View meals"
                    title=""
                    className="text-24pt lg:text-20pt 1xl:text-24pt leading-tight cursor-pointer mt-2"
                    onClick={() => {
                      navigate("/meals");
                    }}
                    textType=""
                  />
                </div> */}
              </div>
            </div>
          )}
        </BodyWrapper>
        <Footer />
      </PageWrapper>
    </>
  );
};

export default PlansPage;
